<template>
	<div id="app" class="app">

		<app-header :name="companyName" :desc="companyDesc"></app-header>

		<div class="cover"></div>

		<main class="app-view">
			<div class="container">

				<!--<ol class="breadcrumb" v-if="$route && $route.matched && $route.matched.length && $route.name !== 'home'">-->
				  	<!--<li><a href="#">Home</a></li>-->
					<!--<li class="active" v-for="route in $route.matched" v-if="route.name !== 'home'">-->
						<!--<router-link :to="{name: route.name}">{{route.meta.linkText}}</router-link>-->
					<!--</li>-->
				<!--</ol>-->

				<app-sidebar></app-sidebar>

				<div class="app-content col-md-9">
					<router-view class="view"></router-view>
				</div>

			</div>
		</main>

		<app-footer :name="companyName" :desc="companyDesc"></app-footer>
	</div>
</template>

<script>
	import appHeader from './components/app/appHeader'
	import appSidebar from './components/app/appSidebar'
	import appFooter from './components/app/appFooter'

	export default {
		name: 'app',
		components: {
			appHeader,
			appSidebar,
			appFooter
		},
		data () {
			return {
			    companyName: 'Weboko',
				companyDesc: 'Web Development'
			}
		}
	}

</script>

<style>
</style>



// WEBPACK FOOTER //
// App.vue?e621c348